import gql from 'graphql-tag';

const GET_BASKET_ITEMS = gql`
  query getBasketItems($transactionId: String!, $appId: String!) {
    getBasketItems(transactionId: $transactionId, appId: $appId)
  }
`;

export default GET_BASKET_ITEMS;
